export default "__VITE_ASSET__y1R37r3I__"